/* eslint-disable @typescript-eslint/no-explicit-any */

export default function Grid(): any {
  return { MuiGrid: { styleOverrides: {} } };
}
